import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from "axios";
import api from "../../configuration/ApiConfig";
import CustomerService from "../../services/CustomerService";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Processing...");
  const [success, setSuccess] = useState(true);
  const paymentIntentId = searchParams.get('payment_intent');

  useEffect(() => {
    const customerDataString = localStorage.getItem("Data");
    const customerData = customerDataString ? JSON.parse(customerDataString) : null;

    const formData = new FormData();
    formData.append("customerFirstName", customerData.customerFirstName);
    formData.append("customerLastName", customerData.customerLastName);
    formData.append("businessName", customerData.businessName);
    formData.append("email", customerData.email);
    formData.append("addressLine1", customerData.addressLine1);
    formData.append("addressLine2", customerData.addressLine2);
    formData.append("city", customerData.city);
    formData.append("state", customerData.state);
    formData.append("zipCode", customerData.zipCode);
    formData.append("password", customerData.password);
    formData.append("signature", customerData.signature);
    formData.append("signFirstName", customerData.signFirstName);
    formData.append("signLastName", customerData.signLastName);
    formData.append("paymentMethod", "card");
    formData.append("transactionId", paymentIntentId);
    formData.append("paymentToken", paymentIntentId);
    formData.append("status", true);
    formData.append("date", new Date().toISOString());
    formData.append("serviceId", 3035);

    if (paymentIntentId && customerData) {
      async function fetchData() {
        try {
         const res = await api.post(
                `Customers/AddCustomerDetails`,
                formData,
                {
                    headers: {
                    'Content-Type': 'multipart/form-data'
                    }
                }
                );

          if (res.data.statusCode === 200) {
            debugger;
            setSuccess(true);
            await handleClick();
          } else {
            setStatus("Payment Failed!");
            setSuccess(false);
          }
        } catch (err) {
          setStatus("Something went wrong!");
          setSuccess(false);
        }
      }
      fetchData();
    } else {
      setStatus("❌ Missing payment or customer data.");
      setSuccess(false);
      localStorage.removeItem("Data");
    }
  }, [paymentIntentId]);

  const handleClick = async () => {
    debugger;
    if (success) {
      const customerDataString = localStorage.getItem("Data");
      const customerData = customerDataString ? JSON.parse(customerDataString) : null;
      
      if (customerData) {
        try {
          const response = await CustomerService.LoginCustomer({
            email: customerData.email,
            password: customerData.password
          });
          
          if (response.status) {
            localStorage.setItem("accessToken", response.resultData.token);
            localStorage.removeItem("Data");
            navigate('/dashboard?showWelcome=true', { replace: true });
          }
        } catch (error) {
          console.error('Login failed:', error);
          navigate('/login');
        }
      } else {
        navigate('/login');
      }
    } else {
      navigate('/register');
    }
  };

  return (
   <div style={{ background: "#f2f2f2", filter: "grayscale(100%)", minHeight: "100vh" }} className="d-flex justify-content-center align-items-center p-3">
  <div
    className="card text-center p-5"
    style={{
      width: "100%",
      maxWidth: "500px",
      borderRadius: "10px",
      background: "#fff",
      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
      transition: "all 0.3s ease-in-out"
    }}
  >
    <div className="mb-4">
      {success === true && (
        <div style={{ fontSize: "60px", color: "#28a745", transition: "0.3s" }}>✅</div>
      )}
      {success === false && (
        <div style={{ fontSize: "60px", color: "#dc3545", transition: "0.3s" }}>❌</div>
      )}
      <h3 className="mt-4 mb-2 display-3" id="main-font" style={{ fontWeight: "600" }}>
        {success ? (
          <>
          <p>Payment Successful!</p>
          <p>Redirecting you in few seconds.</p>
          </>
        ) : success === false ? "Payment Failed" : "Processing..."}
      </h3>
    </div>

    {success === false && (
    <button
      className="btn btn-danger w-100 py-2"
      onClick={handleClick}
      id="main-font"
      style={{
        fontWeight: "500",
        fontSize: "16px",
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
      }}
    >
      Register Again
    </button>
  )}

  </div>
</div>

  );
};

export default PaymentSuccess;
